import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { HomeComponent } from './home';
import { AboutComponent } from './about';
import { WifeTempComponent, WifeDivorcedComponent } from './wife';

import { Step2Component } from './step2';
import { ResultsComponent } from './results';

import { DaughterEligibilityComponent, SonEligibilityComponent, WifeEligibilityComponent, FatherEligibilityComponent, MotherEligibilityComponent, HusbandEligibilityComponent } from './eligibility';
import { SiblingsInfoComponent } from './level2-inheritors';

import { SettingsComponent } from './settings';
import { NotSupportedComponent } from './not-supported';
import { NoContentComponent } from './no-content';

const routes: Routes = [
	{ path: '',		component: HomeComponent },
	{ path: 'home', component: HomeComponent },
	{ path: 'about', component: AboutComponent },

	{ 
		path: 'wife', 
		children: [
			{ path: "temp", 	component: WifeTempComponent },
			{ path: "divorced", component: WifeDivorcedComponent },
		]
	},

	{ path: 'level1-inheritors',  component: Step2Component },
	{ path: 'results',  component: ResultsComponent },

	{ 
		path: 'eligibility', 
		children: [
			{ path: "daughter",	component: DaughterEligibilityComponent },
			{ path: "son",		component: SonEligibilityComponent },
			{ path: "wife",		component: WifeEligibilityComponent },
			{ path: "father",	component: FatherEligibilityComponent },
			{ path: "mother",	component: MotherEligibilityComponent },
			{ path: "husband",	component: HusbandEligibilityComponent },
		]
	},

	{ 
		path: 'level2-inheritors', 
		children: [
			{ path: "siblings",	component: SiblingsInfoComponent },
		]
	},

	{ path: 'not-supported',  component: NotSupportedComponent },
	{ path: 'settings',  component: SettingsComponent },

	{ path: '**',    component: NoContentComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
